export default __webpack_public_path__ + "static/media/edit_icon.0f67b8ba.svg";